import { ActionContext } from 'vuex';
import {ListStateItem, ListModuleItem} from '@/store/shared/index'
import FactoryCost from './entity'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

//定义 interface  常用情况 edit页面entity  codelist等   页面需要的数据对象都要在此声明
interface FactoryCostState extends ListStateItem<FactoryCost>{
    editFactoryCost: FactoryCost;
    securityItem: any;
    allTotal:number;
}

class FactoryCostModule extends ListModuleItem<FactoryCostState,any,FactoryCost>{

    //构造函数 （必须）将派生类中 的overrideState 和 overrideMutations 与基类（ListModuleItem）中的state mutations合并
    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }
    
    //state  页面需要的数据对象都要在此实例化  
    overrideState = {
        editFactoryCost: new FactoryCost(),
        securityItem: {},
        allTotal:null,
    }

    //action中 function 都是异步
    actions = {
   
        //分页查询
        async getAll(context: ActionContext<FactoryCostState, any>, payload: any) {
            context.state.table.loading=true;
            let reponse = await $http.get('/services/app/FactoryCost/GetAllFactory', { params: payload.data });
            context.state.table.loading=false;
            let page = reponse.data.result as PageResult<FactoryCost>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
            // 控制行勾选框是否可勾选：仅确认中的记录可勾选
            page.items.forEach(row => {
                row._disabled = row.factoryConfirmStatus !== 'Confirming';
            });
            if(context.state.table.list.length>0){
                context.state.allTotal=reponse.data.result.allTotal;
            }
            else{
                context.state.allTotal=-1;
            }
        },
        
        //新增
        async create(context: ActionContext<FactoryCostState, any>, payload: any) {
            await $http.post('services/app/FactoryCost/Registration', payload.data);
        },
        //更新
        async update(context: ActionContext<FactoryCostState, any>, payload: any) {
            await $http.put('services/app/FactoryCost/Update', payload.data);
        },
        //删除
        async delete(context: ActionContext<FactoryCostState, any>, payload: any) {
            await $http.delete('/services/app/FactoryCost/Delete?Id=' + payload.data.id);
        },
        //根据id获取单个记录
        async get(context: ActionContext<FactoryCostState, any>, payload: any) {
            
            let reponse = await $http.get('/services/app/FactoryCost/Get?Id=' + payload.id);
            context.state.editFactoryCost=reponse.data.result;
            return reponse.data.result as FactoryCost;
        },
        //确认
        async confirm(context: ActionContext<FactoryCostState, any>, payload: any) {
            await $http.post('services/app/FactoryCost/Confirm', payload.data);
        },
        //撤销
        async revoke(context: ActionContext<FactoryCostState, any>, payload: any) {
            await $http.post('services/app/FactoryCost/Revoke', payload.data);
        },
        //批量确认
        async batchConfirm(context: ActionContext<FactoryCostState, any>, payload: any) {
            await $http.post('services/app/FactoryCost/BatchConfirm', payload.data);
        },
    };

    overrideMutations = {
        edit(state: FactoryCostState, declareCustoms: FactoryCost) {
            state.editFactoryCost = declareCustoms;
        },
        setSecurityItem(state: FactoryCostState, payload: any) {
            state.securityItem = payload.securityItem
        },
    }
}

const factoryCostModule = new FactoryCostModule();
export default factoryCostModule;


